import axios from 'axios';
import config from '../config';

const feedbackUrl = `${config.apiUrl}/feedback/v1/feedback`;

class TableBookingApi {
  static getFeedbackConfig(orderId, feedbackId) {
    return axios
      .get(`${feedbackUrl}/order/${orderId}/orderFeedback/${feedbackId}`)
      .then(res => res.data);
  }

  static getMealFeedback(orderId, feedbackId) {
    return axios
      .get(`${feedbackUrl}/order/${orderId}/orderFeedback/${feedbackId}/mealFeedback`)
      .then(result => {
        const {data} = result;
        if (data && data._embedded && data._embedded.mealFeedbacks) { // eslint-disable-line no-underscore-dangle
          return data._embedded.mealFeedbacks; // eslint-disable-line no-underscore-dangle
        }
        return [];
      });
  }
  static setFeedbackConfig(feedback) {
    return axios
      .put(
        `${feedbackUrl}/order/${feedback.orderId}/orderFeedback/${feedback.uuid}`,
        feedback
      )
      .then(res => res.data);
  }

  static setMealFeedback(feedbackId, mealFeedback) {
    return axios
      .put(
        `${feedbackUrl}/orderFeedback/${feedbackId}/mealFeedback/${mealFeedback.uuid}`,
        mealFeedback
      )
      .then(res => res.data);
  }
}

export default TableBookingApi;



// WEBPACK FOOTER //
// ./api/feedback.api.js